// src/hooks/useNotifications.ts - UPDATED WITH SOUND CONTROLS
import { useContext } from 'react';
import { NotificationContext } from '../context/NotificationContext';
import type { NotificationContextType } from '../types/notification.types';

export const useNotifications = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};

export default useNotifications;